export const matchesMemberQuery = (
    member: { fullName: string; email: string },
    lowercasedQuery: string
) =>
    !lowercasedQuery ||
    member.fullName.toLowerCase().includes(lowercasedQuery) ||
    member.email.toLowerCase().includes(lowercasedQuery)
